import { modalBibliographyTagDataEditStore } from '@/store'
import { ModalBibliographyTagDataEditStoreInterface } from '@/store/ModalBibliographyTagDataEditStore'

export class ModalBibliographyTagDataEditService {
  public open(params: ModalBibliographyTagDataEditStoreInterface) {
    modalBibliographyTagDataEditStore.open(params)
  }

  public close() {
    modalBibliographyTagDataEditStore.close()
  }
}
